import React, { useEffect } from "react";
import dialog from "../../assets/images/pk-events/Group 38187.png";
import close from "../../assets/images/pk-events/close1.png";
import { useTranslation } from "react-i18next";

const Dialog = ({ isOpen, closeDialog, description }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black   bg-opacity-50 flex items-center justify-center z-[999999]">
      <div
        style={{ width: "calc(100% - 20px)" }}
        className="w-[90%]  rounded-xl    relative dialog  shadow-lg"
      >
        <img
          src={dialog}
          alt="dialog"
          className="inset-0 w-full h-full object-cover rounded-2xl"
        />
        <div className="absolute inset-x-0 top-[22%] bottom-[10%] flex justify-center">
          <p
            className="font-medium gradientTextDesc w-[88%] h-full scrollbar-hidden overflow-y-auto text-[16px] leading-[19px] tracking-normal text-start px-6 py-1 flex items-center"
            style={{
              overflowY: "auto", // Add scroll if the content is too long
              whiteSpace: "normal", // Ensure text wraps
            }}
          >
            {description}
          </p>
        </div>

        <p className="absolute top-[26px]    gradientTextRules left-1/2 w-full p-4 z-40 transform -translate-x-1/2 text-[20px] leading-none tracking-normal font-semibold text-center">
          {t("Rules")}
        </p>
        <button
          onClick={closeDialog}
          className="absolute top-[24rem] z-50 right-[47%]"
        >
          <img src={close} alt="close" className="w-8" />
        </button>
      </div>
    </div>
  );
};

export default Dialog;
